import axios from 'axios'
import { Config, setErrorLog } from '../../api/axiosCreate'

// 검사 목록 조회
function getLibraryTestList (UserID, Password, Page, SearchTitle, PartCode) {
  const data = {
    UserID: UserID,
    Password: Password,
    Page: Page,
    SearchTitle: SearchTitle,
    PartCode: PartCode
  }
  return axios.post(Config.baseUrl + 'libraryTestList', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

// 검사 파트 조회
function getCdoeTestPart (UserID, Password) {
  const data = {
    UserID: UserID,
    Password: Password
  }
  return axios.post(Config.baseUrl + 'getCdoeTestPart', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

// 검사 기관 조회
function getCodeLaboratory (UserID, Password) {
  const data = {
    UserID: UserID,
    Password: Password
  }
  return axios.post(Config.baseUrl + 'getCodeLaboratory', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

// 검사 상세 조회
function getLibraryTestInfo (UserID, Password, TestCode) {
  const data = {
    UserID: UserID,
    Password: Password,
    TestCode: TestCode
  }
  return axios.post(Config.baseUrl + 'libraryTestInfo', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

function getLibraryTestSpecimen (UserID, Password, TestCode) {
  const data = {
    UserID: UserID,
    Password: Password,
    TestCode: TestCode
  }
  return axios.post(Config.baseUrl + 'getLibraryTestSpecimen', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}



// 이슈 리마인더 리스트
function getTestIssueReminderList (StartDate, EndDate, UserID, Password, Page, ClientID, ManageGCode) {
  const data = {
    UserID: UserID,
    Password: Password,
    Page: Page,
    StartDate: StartDate,
    EndDate: EndDate,
    ClientID: ClientID,
    ManageGCode: ManageGCode
  }
  return axios.post(Config.baseUrl + 'testIssueReminderList', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

// 이슈 리마인더 등록
function setTestIssueReminder (UserID, Password, ClientID, Id, Issue) {
  const data = {
    UserID: UserID,
    Password: Password,
    Id: Id,
    Issue: Issue,
    ClientID: ClientID
  }
  return axios.post(Config.baseUrl + 'setTestIssueReminder', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

// 이슈 리마인더 등록 - 접수조회
function getInfoTestRequestReceptionL2G (UserID, Password, ClientID, SendDate, SearchStr) {
  const data = {
    UserID: UserID,
    Password: Password,
    ClientID: ClientID,
    SendDate: SendDate,
    SearchStr: SearchStr
  }
  return axios.post(Config.baseUrl + 'getInfoTestRequestReceptionL2G', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

// 이슈 리마인더 푸쉬 알림 시간 설정
function setIssueReminderSendTime (UserID, Password, SendWeekDay, SendTime) {
  const data = {
    UserID: UserID,
    Password: Password,
    SendWeekDay: SendWeekDay,
    SendTime: SendTime
  }
  return axios.post(Config.baseUrl + 'setIssueReminderSendTime', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

// 이슈 리마인더 푸쉬 알림 시간 설정
function deleteIssueReminderSendTime (UserID, Password, ID) {
  const data = {
    UserID: UserID,
    Password: Password,
    ID: ID,
  }
  return axios.post(Config.baseUrl + 'deleteIssueReminderSendTime', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}


// 이슈 리마인더 푸쉬 알림 시간 조회
function getIssueReminderPushTime (UserID, Password) {
  const data = {
    UserID: UserID,
    Password: Password,
  }
  return axios.post(Config.baseUrl + 'getIssueReminderPushTime', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

// 요청관리 리스트
function getTestRequestList (RStartDate, REndDate, UserID, Password, ManageGCode, StateCode, SearchSTR, IsMyRequest, Page, ClientID) {
  const data = {
    UserID: UserID,
    Password: Password,
    Page: Page,
    RStartDate: RStartDate,
    REndDate: REndDate,
    ManageGCode: ManageGCode,
    StateCode: StateCode,
    SearchTitle: SearchSTR,
    IsMyRequest: IsMyRequest,
    ClientID: ClientID
  }
  return axios.post(Config.baseUrl + 'testRequestList', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

// 요청구분/종류 라이브러리
function getCodeRequestClass (UserID, Password) {
  const data = {
    UserID: UserID,
    Password: Password
  }
  return axios.post(Config.baseUrl + 'getCodeRequestClass', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

// 요청관리 상세 조회
function getTestRequest (UserID, Password, TRequestID, TeamCode) {
  const data = {
    UserID: UserID,
    Password: Password,
    TRequestID: TRequestID,
    TeamCode: TeamCode
  }
  return axios.post(Config.baseUrl + 'testRequest', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

// 요청 추가 수진자 목록 조회
function getTestRequestReceptionList (UserID, Password, ReceptionDate, PatientName, ClientID, Page) {
  const data = {
    UserID: UserID,
    Password: Password,
    ReceptionDate: ReceptionDate,
    PatientName: PatientName,
    ClientID: ClientID,
    Page: Page
  }
  return axios.post(Config.baseUrl + 'testRequestReception', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

// 검체 용기 목록 조회
function getSpecimenContainerList (UserID, Password) {
  const data = {
    UserID: UserID,
    Password: Password
  }
  return axios.post(Config.baseUrl + 'specimenContainerList', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

// 접수 검사항목 조회
function getTestRequestReceptionItem (UserID, Password, ReceptionRegNum, ReceptionDate) {
  const data = {
    UserID: UserID,
    Password: Password,
    ReceptionRegNum: ReceptionRegNum,
    ReceptionDate: ReceptionDate
  }
  return axios.post(Config.baseUrl + 'testRequestReceptionItem', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

// 특정 검사의 검체 목록 조회
function getSpecimenList (UserID, Password, TestCode) {
  const data = {
    UserID: UserID,
    Password: Password,
    TestCode: TestCode
  }
  return axios.post(Config.baseUrl + 'specimenList', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

// 자주 쓰는 요청 라이브러리
function getFavoriteRequests () {
  return axios.post(Config.baseUrl + 'favoriteRequests', null, {
  })
}

// 요청 추가 및 수정
function setInfoTestRequest (UserID, Password, InfoTestRequest) {
  const data = {
    UserID: UserID,
    Password: Password,
    InfoTestRequest: InfoTestRequest
  }
  return axios.post(Config.baseUrl + 'infoTestRequest', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

// 요청 삭제
function delInfoTestRequest (UserID, Password, TRequestID, TeamCode) {
  const data = {
    UserID: UserID,
    Password: Password,
    TRequestID: TRequestID,
    TeamCode: TeamCode
  }
  return axios.post(Config.baseUrl + 'delInfoTestRequest', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

// 부적합 목록 조회
function getInfoTestIncongruityList (UserID, Password, Page, PStartDate, PEndDate, ClientID, PatientName, ManageGCode, Status, IsNotice) {
  const data = {
    UserID: UserID,
    Password: Password,
    Page: Page,
    PStartDate: PStartDate,
    PEndDate: PEndDate,
    ClientID: ClientID,
    PatientName: PatientName,
    ManageGCode: ManageGCode,
    Status: Status,
    IsNotice: IsNotice
  }
  return axios.post(Config.baseUrl + 'getInfoTestIncongruityList', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

// 부적합 상세 조회
function getInfoTestIncongruityDetail (UserID, Password, TIncongruityID) {
  const data = {
    UserID: UserID,
    Password: Password,
    TIncongruityID: TIncongruityID
  }
  return axios.post(Config.baseUrl + 'getInfoTestIncongruity', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

// 부적합의 관한 요청 조회
function getInfoTestReqequestForIncongruity (UserID, Password, ReceptionDate, ReceptionRegNum) {
  const data = {
    UserID: UserID,
    Password: Password,
    ReceptionDate: ReceptionDate,
    ReceptionRegNum: ReceptionRegNum
  }
  return axios.post(Config.baseUrl + 'getInfoTestReqequestForIncongruity', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

// 부적합 피드백 등록 및 편집
function setInfoTestIncongruityFeedback (UserID, Password, TIFeedbackID, TIncongruityID, ManageGCode, FeedbackNotes, EditorID) {
  const data = {
    UserID: UserID,
    Password: Password,
    TIFeedbackID: TIFeedbackID,
    TIncongruityID: TIncongruityID,
    ManageGCode: ManageGCode,
    FeedbackNotes: FeedbackNotes,
    EditorID: EditorID
  }
  return axios.post(Config.baseUrl + 'setInfoTestIncongruityFeedback', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

// 부적합 피드백 삭제
function delInfoTestIncongruityFeedback (UserID, Password, TIFeedbackID, EditorID) {
  const data = {
    UserID: UserID,
    Password: Password,
    TIFeedbackID: TIFeedbackID,
    EditorID: EditorID
  }
  return axios.post(Config.baseUrl + 'delInfoTestIncongruityFeedback', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

// 리포트 타입 조회
function getCodeTestReportType (UserID, Password) {
  const data = {
    UserID: UserID,
    Password: Password
  }
  return axios.post(Config.baseUrl + 'getCodeTestReportType', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

// 검사 결과 환자 리스트
function getWebResultMasterList (UserID, Password, FromDate, ToDate, SearchValue, RptTypeCode, ClientID, Page) {
  const data = {
    UserID: UserID,
    Password: Password,
    FromDate: FromDate,
    ToDate: ToDate,
    SearchValue: SearchValue,
    RptTypeCode: RptTypeCode,
    ClientID: ClientID,
    Page: Page
  }
  return axios.post(Config.baseUrl + 'getWebResultMasterList', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

// 검사 결과
function getWebResultList (UserID, Password, ReceptionID, RptTypeCode) {
  const data = {
    UserID: UserID,
    Password: Password,
    ReceptionID: ReceptionID,
    RptTypeCode: RptTypeCode
  }
  return axios.post(Config.baseUrl + 'getWebResultList', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

export {
  getLibraryTestList,
  getLibraryTestInfo,
  getTestRequestList,
  getTestRequest,
  getTestRequestReceptionList,
  getSpecimenContainerList,
  getTestRequestReceptionItem,
  getSpecimenList,
  getFavoriteRequests,
  setInfoTestRequest,
  delInfoTestRequest,
  getInfoTestIncongruityList,
  getInfoTestIncongruityDetail,
  setInfoTestIncongruityFeedback,
  delInfoTestIncongruityFeedback,
  getCdoeTestPart,
  getCodeLaboratory,
  getCodeTestReportType,
  getWebResultMasterList,
  getWebResultList,
  getInfoTestReqequestForIncongruity,
  getCodeRequestClass,
  getTestIssueReminderList,
  setTestIssueReminder,
  getInfoTestRequestReceptionL2G,
  setIssueReminderSendTime,
  getIssueReminderPushTime,
  deleteIssueReminderSendTime,
  getLibraryTestSpecimen
}
